import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import {
    EnvironmentProviders,
    Provider,
    inject,
    provideEnvironmentInitializer,
} from '@angular/core';

import { AuthService } from 'app/core/auth/auth.service';
import { authInterceptor } from '../interceptors/authinterceptors';
import { HttpErrorInterceptor } from '../interceptors/http-interceptors';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideHttpClient(withInterceptors([authInterceptor])),
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        provideEnvironmentInitializer(() => inject(AuthService)),
    ];
};
